export const getTrackingData = ({search, appliedFilters, totalResults}) => {
  const {bodyType, category2, fuelType, make, model, modelVersion} = appliedFilters || {}
  const {doors, hp, litres, price, sortBy, page, version, year} = search || {}

  const filters = {
    body_type: bodyType || category2 || undefined,
    brand: make,
    cc_min: Number(litres?.from) || undefined,
    cc_max: Number(litres?.to) || undefined,
    doors: (typeof doors !== 'undefined' && Number(...doors)) || undefined,
    fuel_type: fuelType,
    model: model || modelVersion || undefined,
    order: sortBy,
    power_min: Number(hp?.from) || undefined,
    power_max: Number(hp?.to) || undefined,
    price_min: Number(price?.from) || undefined,
    price_max: Number(price?.to) || undefined,
    version,
    year_min: Number(year?.from) || undefined,
    year_max: Number(year?.to) || undefined
  }

  return {
    ...(filters !== {} && {filters}),
    searchResultsCount: totalResults,
    pageNumber: page
  }
}
